import type { Dictionnaire } from '../type';

export const messages: Dictionnaire['messages'] = {
  amis: {
    croise: '你们在活动中见过面',
    soiMeme: '你不能添加自己',
    compteOfficiel: '应用官方账号不能加为好友。你可以给它发消息。',
    bloque: '你已屏蔽这位成员：请先解除屏蔽，再发送好友申请',
    refuse: '这位成员暂时不接受你的申请',
    plusDeDemande: '这个申请已不存在',
    nouveau: '新来的成员',
  },
  erreurs: {
    plusDeConversation: '这个对话已不存在',
    pasMembre: '你不在这个对话中',
    demandeEnAttente: '消息已发送。对方回复后，你们就可以继续聊了。',
    plusAmis: '你们已不是好友：这个对话已关闭',
    injoignable: '对方暂时收不到你的消息',
    vide: '发送前先写点什么',
    effacerLesSiens: '你只能删除自己的消息',
    modifierLesSiens: '你只能编辑自己的消息',
    tropTardPourModifier: '消息只能在发送后 15 分钟内编辑。',
    priveSansNom: '私聊没有名称',
    renommerAdmin: '只有管理员可以重命名群组',
    nomDuGroupe: '给群组起个名字',
    priveSansDescription: '私聊没有简介',
    descriptionAdmin: '只有管理员可以修改简介',
    priveSansAdmin: '私聊没有管理员',
    passerAdmin: '只有群管理员可以转交',
    plusDansLeGroupe: '这位成员已不在群组中',
    priveSansMembres: '私聊没有成员',
    retirerAdmin: '只有群管理员可以移除成员',
    utiliseQuitter: '请使用“退出群组”',
    priveSansPhoto: '私聊没有头像',
    photoAdmin: '只有群管理员可以更换群头像',
    soiMeme: '你不能和自己聊天',
    bloque: '你已屏蔽这位成员。请在其资料页解除屏蔽后再发消息。',
    priveFermee: '私聊不能加入其他成员',
    groupeDeSortie: '参加活动即可加入这个群组，无法通过邀请加入',
    groupeDAsso: '加入社团即可加入这个群组，无法通过邀请加入',
    amisSeulement: '你只能把好友拉进群组',
    priveNeSeQuittePas: '私聊无法退出',
    successeur: '退出前请选择由谁接管群组。',
  },
  apercu: {
    groupe: '群组',
    photo: '照片',
    vocal: '语音消息',
    video: '视频',
    sortie: '分享的活动',
    post: '分享的帖子',
    nouveau: '新消息',
  },
  commun: {
    photo: '照片',
    vocal: '语音消息',
    video: '视频',
    sortie: '分享的活动',
    post: '分享的帖子',
    message: '消息',
    supprime: '消息已删除',
    ecrit: '正在输入…',
    nouveauMessage: '新消息',
    quitterGroupe: '退出群组',
    aucunMembre: '没有找到成员',
    verifie: '请检查用户名的拼写。',
    aucunAmi: '还没有好友',
    chercheUnPseudo: '搜索用户名，邀请还不是你好友的人。',
    rechercherPseudo: '搜索用户名…',
    infosGroupe: '群组信息',
    membres: '成员',
    toi: '你',
    moi: '我',
    retirerQuelquun: (nom: string) => `移除 ${nom}`,
    laisserEtPartirQ: (nom: string) => `把群组交给 ${nom} 并退出？`,
  },
  conversation: {
    pasParti: '这条消息未能发送。',
    pasModifie: '这条消息未能编辑。',
    microIndisponible: '麦克风不可用',
    vocalImpossible: '语音消息发送失败',
    envoiImpossible: '暂时无法发送。',
    copie: '消息已复制。',
    plusCharge: '这条消息已不在对话已加载的部分中。',
    reactionEchec: '回应没有成功。请重试。',
    effacement: '消息在被阅读一周后删除。',
    pasAmis: '你们还不是好友：你只能发送一条消息。对方回复后，对话才会开启。',
    dernierMessage: '跳到最新消息',
    plusAmis: '你们已不是好友：这个对话已关闭。在对方资料页重新发送好友申请即可继续聊天。',
    voirCite: '查看被引用的消息',
    annulerReponse: '取消回复这条消息',
    annulerModif: '取消编辑这条消息',
    modifierLeMessage: '编辑消息',
    ecrire: '写消息…',
    annulerEnregistrement: '取消录音',
    reprendre: '继续录音',
    galerie: '从相册选择',
    enregistrerVocal: '录制语音消息',
    lacherAnnuler: '松开取消',
    lacherEnvoyer: '松开发送',
    envoyerVocal: '发送语音消息',
    envoyer: '发送',
    actions: '消息操作',
    autreEmoji: '选择其他表情',
    repondre: '回复',
    copier: '复制文字',
    modifier: '编辑',
    infos: '详情',
    supprimerQ: '删除这条消息？',
    supprimer: '删除',
    chercherEmoji: '搜索表情',
    reactions: '回应',
    retraitEchec: '移除没有成功。请重试。',
    appuyerSupprimer: '点击即可移除。',
    infosMessage: '消息详情',
    vu: '已读',
    pasEncore: '尚未',
    distribue: '已送达',
    ceMembre: '这位成员',
    photoEnvoyee: '对话中发送的照片',
    voirReactions: '查看谁做了回应',
    postIndisponible: '这条帖子已不可用。',
    voirProfil: (nom: string) => `查看 ${nom} 的资料`,
    plusieursEcrivent: (n: number) => `${n} 人正在输入…`,
    appelerVideo: (nom: string) => `与 ${nom} 视频通话`,
    appeler: (nom: string) => `给 ${nom} 打电话`,
    nouveaux: (n: number) => `${n} 条新消息`,
    retirerReaction: (emoji: string) => `移除 ${emoji}`,
    reagirAvec: (emoji: string) => `用 ${emoji} 回应`,
    aucunEmoji: (quete: string) => `没有与“${quete}”匹配的表情。`,
    systeme: {
      retire: (nom: string) => `${nom} 已被移出群组。`,
      rejoint: (nom: string) => `${nom} 加入了群组。`,
      quitte: (nom: string) => `${nom} 退出了群组。`,
      tuAsQuitte: '你已退出群组。',
      plusAmi: (nom: string) => `你和 ${nom} 已不是好友。重新成为好友后，对话将继续。`,
    },
    appel: {
      manque: (video: boolean) => `未接${video ? '视频' : ''}来电`,
      duree: (video: boolean, duree: string) => `${video ? '视频通话' : '通话'} · ${duree}`,
    },
    lu: '已读',
    modifie: '已编辑',
  },
  ajouterAmis: {
    titre: '添加好友',
    boutons: {
      none: '添加',
      requested: '已申请',
      incoming: '接受',
      friends: '好友',
    },
    demandesRecues: (n: number) => `收到的申请 · ${n}`,
    suggestions: (lieu: string | null) => `推荐${lieu ? `（${lieu}）` : ''}`,
    tousLesMembres: (n: number) => `所有成员 · ${n}`,
    accepter: (nom: string) => `接受 ${nom}`,
    refuser: (nom: string) => `拒绝 ${nom}`,
  },
  ajouterMembres: {
    impossible: '暂时无法添加。',
    titre: '添加成员',
    choisis: '选择要添加的人',
    resultats: '结果',
    tesAmis: '你的好友',
    dejaMembre: '已是成员',
    ajouter: (n: number) => `添加 ${n} 位成员`,
  },
  groupe: {
    descriptionImpossible: '简介未能保存',
    renommageImpossible: '重命名失败',
    passerImpossible: '转交失败',
    retirerImpossible: '无法移除这位成员',
    photoImpossible: '照片未能保存',
    quitterImpossible: '无法退出群组',
    quitterQ: '退出群组？',
    nommerAdmin: '设为管理员',
    retirer: '移出群组',
    changerPhoto: '更换群头像',
    voirPhoto: '全屏查看群头像',
    modifierNom: '修改群名称',
    ajouterMembre: '添加成员',
    modifierDescription: '修改群简介',
    ajouterDescription: '添加简介',
    deQuoi: '这个群组是关于什么的？',
    admin: '管理员',
    retirerQ: (nom: string) => `把 ${nom} 移出群组？`,
    meta: (n: number, date: string) => `${n} 位成员 · 创建于 ${date}`,
  },
  passation: {
    orphelin: '你要把群组托付给谁？',
    laisser: '你要把群组留给谁？',
  },
  demandes: {
    titre: '消息请求',
    aucune: '没有请求',
    aucuneAide: '你还不认识的成员发来的第一条消息会出现在这里。',
  },
  liste: {
    supprimerQ: '删除这个对话？',
    nouveauGroupe: '新建群组',
    demandesMessage: '消息请求',
    ajouterAmis: '添加好友',
    reactiverSon: '取消静音',
    sourdine: '静音',
    signaler: '举报对话',
    supprimer: '删除对话',
    vide: '还没有消息',
    videAide: '在成员资料页给对方写消息，或参加一次聚会来认识大家。',
    rechercher: '搜索对话…',
    discussions: '对话',
    messages: '消息',
    comptes: '账号',
    envoyerUnMessage: '发送消息',
    toiDeuxPoints: '你：',
    enSourdine: '已静音',
    plusAmis: '你们已不是好友',
    appelManque: '未接来电',
    appel: '通话',
    premier: '发送第一条消息吧！',
    quitterQ: (nom: string) => `退出 ${nom}？`,
    demandesMessageEnAttente: (n: number) => `消息请求 · ${n} 条待处理`,
    demandesAmiEnAttente: (n: number) => `好友申请 · ${n} 条待处理`,
    laisserEtPartirQ: (groupe: string, nom: string) => `把 ${groupe} 交给 ${nom} 并退出？`,
    aucuneDiscussion: (recherche: string) => `没有与“${recherche}”匹配的对话。`,
    auteur: (nom: string) => `${nom}：`,
    nonLus: '新消息',
    systeme: {
      quitte: (nom: string) => `${nom} 退出了群组`,
      retire: (nom: string) => `${nom} 已被移出群组`,
      rejoint: (nom: string) => `${nom} 加入了群组`,
    },
  },
  nouveauGroupe: {
    impossible: '暂时无法创建。',
    titre: '新建群组',
    creer: '创建群组',
    choisirPhoto: '选择群头像',
    nom: '群名称',
    nomExemple: '野餐',
    description: '简介',
    descriptionExemple: '天气好的时候我们在公园见',
    chercher: '搜索任意用户名…',
    selectionnes: (n: number) => `已选择 ${n} 人`,
  },
  annuaire: {
    rechercher: '搜索成员',
    vide: '暂时还没有其他人',
    videAide: '服务器成员获得访问权限后会显示在这里。',
    aucun: (recherche: string) => `没有与“${recherche}”匹配的成员`,
    ecrireA: (nom: string) => `给 ${nom} 发消息`,
    formation: {
      aide: '你会出现在名录中对应的分组里。',
      actuelle: '你的项目',
    },
    sansFormation: '未填写项目',
    voir: (nom: string) => `查看成员：${nom}`,
    videFormation: '这个项目暂时还没有人',
    accueil: {
      etudiants: '学生',
      etudiantsAide: '所有同学，按项目分组',
      associations: '社团',
      associationsAide: '社团动态、活动，以及如何加入',
    },
    maFormation: {
      bouton: '我的项目',
      choisir: '填写我的项目',
      aucune: '不填写',
      enregistree: '项目已保存',
      impossible: '无法保存你的项目，请重试。',
    },
    associations: {
      titre: '社团',
      categories: { bde: '学生会', citoyennes: '公益', creatives: '创意', culturelles: '文化', humanitaires: '人道援助', conviviales: '联谊', internationales: '国际', professionnelles: '职业', sportives: '体育与俱乐部' },
      vide: '暂时还没有社团',
      rechercher: '搜索社团',
      aucune: (recherche: string) => `没有与“${recherche}”匹配的社团`,
      membres: (n: number) => `${n} 名成员`,
      chef: '负责人',
      membre: '成员',
      enAttente: '申请已发送',
      rejoindre: '申请加入',
      annulerDemande: '取消申请',
      quitter: '退出社团',
      quitterQ: (nom: string) => `退出 ${nom}？`,
      demandeEnvoyee: '申请已发送给负责人',
      fil: '动态',
      evenements: '活动',
      lesMembres: '成员',
      ecrire: '在动态里发布',
      creerEvenement: '创建活动',
      filVide: '动态里还没有内容',
      evenementsVide: '暂无即将举行的活动',
      demandes: (n: number) => `加入申请（${n}）`,
      accepter: (nom: string) => `接受 ${nom}`,
      refuser: (nom: string) => `拒绝 ${nom}`,
      retirer: (nom: string) => `将 ${nom} 移出社团`,
      retirerQ: (nom: string) => `将 ${nom} 移出社团？`,
      sansChef: '这个社团还没有负责人来处理申请。',
      reserveMembres: '所有人都能看到它的动态和活动，只有成员可以发布。',
      groupe: '社团群组',
      groupePasPret: '群组正在创建，请稍后再试。',
      introuvable: '找不到该社团',
      impossible: '操作失败，请重试。',
      dansLeFil: (nom: string) => `发布在 ${nom} 的动态里`,
      pourLAsso: (nom: string) => `${nom} 的活动`,
      voir: (nom: string) => `查看社团 ${nom}`,
    },
    filtres: {
      titre: '筛选',
      filtrer: '筛选成员',
      actifs: '已筛选',
      formation: '项目',
      langues: '语言',
      effacer: '全部清除',
      fermer: '查看成员',
      aucun: '没有符合这些条件的成员',
    },
  },
};
